import { render, staticRenderFns } from "./SentViewSection.vue?vue&type=template&id=3b26c278&scoped=true"
import script from "./SentViewSection.vue?vue&type=script&lang=js"
export * from "./SentViewSection.vue?vue&type=script&lang=js"
import style0 from "./SentViewSection.vue?vue&type=style&index=0&id=3b26c278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b26c278",
  null
  
)

export default component.exports